// Sperrt den Seiten-Scroll, solange ein Filter-Drawer (isOpen) offen ist. Unter Windows mit Overlay-Bildlaufleisten liegt
// die Leiste der Seite sonst genau ueber der des Drawers und wird beim Ziehen statt dieser bewegt (Kunde, Firefox, 03.11.).
const setLocked = (locked) => {
  document.documentElement.style.overflow = locked ? "hidden" : "";
};

export const DrawerScrollLockMixin = {
  watch: {
    isOpen(open) {
      setLocked(open);
    },
  },
  beforeDestroy() {
    if (this.isOpen) setLocked(false);
  },
};
